/* eslint-disable no-const-assign */
/* eslint-disable react-hooks/exhaustive-deps */
import React from 'react'
import { MapContainer, TileLayer, Popup, Marker, useMap } from 'react-leaflet'
import { Link } from 'react-router-dom'
import 'leaflet/dist/leaflet.css'
import L from 'leaflet'
import { AiOutlineLeftCircle } from 'react-icons/ai'
import { UploadsUrl } from '../../services/url'
const icon = L.icon({
  iconSize: [25, 41],
  iconAnchor: [10, 41],
  popupAnchor: [2, -40],
  iconUrl: '/images/maker.png',
})

function ChangeMapView({ coords }) {
  const map = useMap()
  map.setView(coords, map.getZoom())
  return null
}

const MapPage = (props) => {
  return (
    <MapContainer
      className='map box-shadow'
      center={props.lawyer.coordinates}
      zoom={12}
      scrollWheelZoom={true}
    >
      <TileLayer
        attribution='&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
        url='https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png'
      />
      <Marker position={props.lawyer.coordinates} icon={icon}>
        <Popup>
          <div className='user-marker'>
            <div>
              <img src={`${UploadsUrl}/${props.lawyer.avatar}`} alt='user' />
            </div>
            <div className='detail-marker'>
              <h5>{props.lawyer.fname}</h5>
              <div>
                <span>
                  <AiOutlineLeftCircle size={20} />
                </span>
                <Link
                  className='link'
                  to={`/detail-lawyer/${props.lawyer._id}`}
                >
                  جزئیات بیشتر
                </Link>
              </div>
            </div>
          </div>
        </Popup>
      </Marker>
      <ChangeMapView coords={props.lawyer.coordinates} />
    </MapContainer>
  )
}
export default MapPage
